<template>
  <CustomModal :value="show" :title="title" @cancel="cancel" @save="save">
    <ValidationObserver
      ref="formModalObserver"
      tag="form"
      novalidate
      @submit.prevent="handleModalSubmit"
    >
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="field.txtNombre.isRequired ? 'required' : ''"
            >
              <CustomInput
                :id="field.txtNombre.id"
                v-model="field.txtNombre.value"
                type="text"
                :label="field.txtNombre.label"
                :error="errors[0]"
                :custom-error-msg.sync="field.txtNombre.errorMsg"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="field.cboParentesco.isRequired ? 'required' : ''"
            >
              <CustomDropDown
                :id="field.cboParentesco.id"
                v-model="field.cboParentesco.selected"
                :label="field.cboParentesco.label"
                :fieldkey="field.cboParentesco.fieldKey"
                :fieldname="field.cboParentesco.fieldName"
                :placeholder="field.cboParentesco.placeHolder"
                :error="errors[0]"
                :custom-error-msg.sync="field.cboParentesco.errorMsg"
                :options="field.cboParentesco.items"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="
                'email' +
                  (field.chkAdministrarCorreoElectronico.selected
                    ? ''
                    : '|required')
              "
            >
              <CustomInput
                :id="field.txtCorreoElectronico.id"
                v-model="field.txtCorreoElectronico.value"
                :name="field.txtCorreoElectronico.label"
                type="email"
                :label="field.txtCorreoElectronico.label"
                :error="errors[0]"
                :custom-error-msg.sync="field.txtCorreoElectronico.errorMsg"
                :disabled="field.chkAdministrarCorreoElectronico.selected"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="col-6 pt-4">
          <div class="custom-control custom-checkbox">
            <input
              :id="field.chkAdministrarCorreoElectronico.id"
              v-model="field.chkAdministrarCorreoElectronico.selected"
              type="checkbox"
              class="custom-control-input"
              @change="chkAdministrarCorreoElectronicoChange()"
            />
            <label
              class="custom-control-label font regular"
              :for="field.chkAdministrarCorreoElectronico.id"
            >
              {{ field.chkAdministrarCorreoElectronico.label }}
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="field.txtTelefono.isRequired ? 'required' : ''"
            >
              <CustomInput
                :id="field.txtTelefono.id"
                v-model="field.txtTelefono.value"
                :mask-type="'Phone'"
                :label="field.txtTelefono.label"
                :error="errors[0]"
                :custom-error-msg.sync="field.txtTelefono.errorMsg"
                placeholder="(___) ___-____"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="col-6 pt-4">
          <div class="custom-control custom-checkbox">
            <input
              :id="field.chkRecibirMensajesTexto.id"
              v-model="field.chkRecibirMensajesTexto.selected"
              type="checkbox"
              class="custom-control-input"
            />
            <label
              class="custom-control-label font regular"
              :for="field.chkRecibirMensajesTexto.id"
            >
              {{ field.chkRecibirMensajesTexto.label }}
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="field.chkRecibirMensajesTexto.selected" class="col-6">
          <div class="form-group">
            <ValidationProvider
              v-slot="{ errors }"
              mode="eager"
              :rules="field.cboProveedor.isRequired ? 'required' : ''"
            >
              <CustomDropDown
                :id="field.cboProveedor.id"
                v-model="field.cboProveedor.selected"
                :disabled="field.cboProveedor.disabled"
                :label="field.cboProveedor.label"
                :fieldkey="field.cboProveedor.fieldKey"
                :fieldname="field.cboProveedor.fieldName"
                :placeholder="field.cboProveedor.placeHolder"
                :error="errors[0]"
                :custom-error-msg.sync="field.cboProveedor.errorMsg"
                :options="field.cboProveedor.items"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </CustomModal>
</template>

<script>
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import CustomModal from '@/components/common/CustomModal';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomInput from '@/components/common/CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'CustomContactInfoModal',
  mixins: [alert],
  components: {
    CustomModal,
    CustomDropDown,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  props:{
    studentSieParam: {
      default: null
    },
  },
  data: () => ({
    ValidationTriggered: store.getters.getatValidationTriggered,
    apiUrl: '/api/student',
    title: 'Verificar información de contacto',
    show: false,
    regStudentId: null,
    field: {
      txtNombre: {
        id: 'txtNombre',
        label: 'Nombre:',
        value: null,
        isRequired: true,
        errorMsg: 'El nombre de la persona contacto es requerido. (0170)',
      },
      txtCorreoElectronico: {
        id: 'txtCorreoElectronico',
        label: 'Correo Electrónico:',
        value: null,
        isRequired: true,
        errorMsg: 'El campo Correo Electrónico es requerido. (0518)',
        principalEmail: null,
        contactEmail: null,
      },
      txtTelefono: {
        id: 'txtTelefono',
        label: 'Teléfono:',
        value: null,
        isRequired: true,
        errorMsg: 'El telefóno es requerido. (0172)',
      },
      cboParentesco: {
        id: 'cboParentesco',
        label: 'Parentesco:',
        fieldKey: 'eduespCodeId',
        fieldName: 'spaShortDescription',
        placeHolder: 'Seleccione',
        isRequired: true,
        errorMsg:
          'Favor de seleccionar un parentesco de otro familiar o persona contacto. (0406)',
        items: [],
        selected: null,
        defaultEduespCodeId: null,
      },
      cboProveedor: {
        disabled: false,
        id: 'cboProveedor',
        label: 'Proveedor:',
        fieldKey: 'telephoneProviderNo',
        fieldName: 'telephoneProviderName',
        placeHolder: 'Seleccione',
        isRequired: true,
        errorMsg: 'El campo de Proveedor es requerido.',
        items: [],
        selected: null,
        defaultTelephoneProviderNo: null,
      },
      chkAdministrarCorreoElectronico: {
        id: 'chkAdministrarCorreoElectronico',
        label: 'No desea administrar un correo electrónico',
        selected: null,
      },
      chkRecibirMensajesTexto: {
        id: 'chkRecibirMensajesTexto',
        label: 'Desea recibir mensajes de texto',
        selected: null,
      },
    },
  }),
  computed: {
    studentSie() { return this.studentSieParam ?? store.getters['$_student/StudentSie']; }
  },
  methods: {
    chkAdministrarCorreoElectronicoChange() {
      this.field.txtCorreoElectronico.value = this.field
        .chkAdministrarCorreoElectronico.selected
        ? this.field.txtCorreoElectronico.principalEmail
        : this.field.txtCorreoElectronico.contactEmail;
    },
    async open() {
      await this.getContactInformation();
      await this.getParentesco();
      await this.getProveedor();

      this.show = true;
    },
    async getContactInformation() {
      let self = this;
      await self
        .$ApiGet(`${this.apiUrl}/${this.studentSie}/ContactInformation`)
        .then((res) => {
          if (res.data) {
            const data = res.data;

            self.regStudentId = data.regStudentId;

            self.field.txtCorreoElectronico.principalEmail =
              data.principalEmail;
            self.field.txtCorreoElectronico.contactEmail = data.contactEmail;

            self.field.txtNombre.value = data.contactName;
            self.field.txtCorreoElectronico.value = data.emailSuppliedFlag
              ? data.principalEmail
              : data.contactEmail;
            self.field.txtTelefono.value = data.contactTelephone;
            self.field.chkAdministrarCorreoElectronico.selected =
              data.emailSuppliedFlag;
            self.field.chkRecibirMensajesTexto.selected =
              data.receiveMessageTextFlag;

            if (data.contactRelation && data.contactRelation > 0) {
              self.field.cboParentesco.defaultEduespCodeId =
                data.contactRelation;
            }

            if (
              data.contactTelephoneProviderCode &&
              data.contactTelephoneProviderCode > 0
            ) {
              this.field.cboProveedor.defaultTelephoneProviderNo =
                data.contactTelephoneProviderCode;
            }
          }
        });
    },
    async getParentesco() {
      let self = this;

      await self.$ApiGet(`${this.apiUrl}/EduEspCodes`).then((res) => {
        if (res.data) {
          const data = res.data;
          self.field.cboParentesco.items = data;

          if (self.field.cboParentesco.defaultEduespCodeId) {
            const selected = self.field.cboParentesco.items.find(
              (x) =>
                x.eduespCodeId === self.field.cboParentesco.defaultEduespCodeId
            );

            if (selected) {
              self.field.cboParentesco.selected = selected;
            }
          }
        }
      });
    },
    async getProveedor() {
      let self = this;

      await self.$ApiGet(`${this.apiUrl}/TelephoneProviders`).then((res) => {
        if (res.data) {
          const data = res.data;

          self.field.cboProveedor.items = data;

          if (self.field.cboProveedor.defaultTelephoneProviderNo) {
            const selected = self.field.cboProveedor.items.find(
              (x) =>
                x.telephoneProviderNo ===
                self.field.cboProveedor.defaultTelephoneProviderNo
            );

            if (selected) {
              self.field.cboProveedor.selected = selected;
              self.field.chkRecibirMensajesTexto.selected = true;
            }
          }
        }
      });
    },
    async cancel() {
      await this.$refs.formModalObserver.reset();
      this.show = false;
      this.$emit('cancel');
    },
    async save() {
      let self = this;

      const isValid = await self.$refs.formModalObserver.validate();

      if (isValid) {
        const params = {
          contactname: self.field.txtNombre.value,
          contactemail: self.field.txtCorreoElectronico.value,
          emailsuppliedflag:
            self.field.chkAdministrarCorreoElectronico.selected,
          contacttelephone: self.field.txtTelefono.value,
          contacttelephoneprovidercode: self.field.chkRecibirMensajesTexto
            .selected
            ? self.field.cboProveedor.selected.telephoneProviderNo
            : null,
          regstudentid: self.regStudentId,
          contactrelation: self.field.cboParentesco.selected.eduespCodeId,
          receivemessagetextflag: self.field.chkRecibirMensajesTexto.selected,
        };

        self.show = false;
        self.$emit('save', params);
      } else {
        this.ShowToast('Atención', 'Por favor, complete los campos!', 'error');
      }
    },
  },
};
</script>
